module.exports = {"category":"Motor Racing"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/configurations/category.json
// module id = 634
// module chunks = 0